var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "", "fill-height": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-form",
            [
              _vm.$v.name.$error
                ? _c("div", { staticClass: "red--text" }, [
                    _vm._v("Please enter name")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "Name" },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("h4", [_vm._v("Wand Option")]),
                  _vm._v(" "),
                  _vm.$v.variations.wandOption.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please select Wand Option")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-radio-group",
                    {
                      attrs: { row: "" },
                      model: {
                        value: _vm.variations.wandOption,
                        callback: function($$v) {
                          _vm.$set(_vm.variations, "wandOption", $$v)
                        },
                        expression: "variations.wandOption"
                      }
                    },
                    [
                      _c("v-radio", {
                        attrs: {
                          label: "910mm",
                          color: "primary",
                          value: "910mm"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-radio", {
                        attrs: {
                          label: "1220mm",
                          color: "primary",
                          value: "1220mm"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-radio", {
                        attrs: {
                          label: "1520mm",
                          color: "primary",
                          value: "1520mm"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-radio", {
                        attrs: {
                          label: "No Wand",
                          color: "primary",
                          value: "No Wand"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: { label: "Manual Fabric?", color: "primary" },
                on: {
                  change: function($event) {
                    return _vm.resetFabricInfo()
                  }
                },
                model: {
                  value: _vm.manual,
                  callback: function($$v) {
                    _vm.manual = $$v
                  },
                  expression: "manual"
                }
              }),
              _vm._v(" "),
              !_vm.manual
                ? [
                    _vm.$v.variations.fabricColorLabel.$error
                      ? _c("div", { staticClass: "red--text" }, [
                          _vm._v("Please enter Fabric - Colour Label")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: { label: "Fabric - Colour Label" },
                      model: {
                        value: _vm.variations.fabricColorLabel,
                        callback: function($$v) {
                          _vm.$set(_vm.variations, "fabricColorLabel", $$v)
                        },
                        expression: "variations.fabricColorLabel"
                      }
                    })
                  ]
                : [
                    _vm.$v.variations.brand.$error
                      ? _c("div", { staticClass: "red--text" }, [
                          _vm._v("Please select Brand")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-autocomplete", {
                      attrs: {
                        items: _vm.brands,
                        "item-value": "_id",
                        label: "Brand",
                        filter: _vm.filterBrandAndRange
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "selection",
                          fn: function(data) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(data.item.name) +
                                  "\n          "
                              )
                            ]
                          }
                        },
                        {
                          key: "item",
                          fn: function(data) {
                            return [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", {
                                    domProps: {
                                      innerHTML: _vm._s("" + data.item.name)
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.selectedBrand,
                        callback: function($$v) {
                          _vm.selectedBrand = $$v
                        },
                        expression: "selectedBrand"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "v-card__actions" },
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { small: "", flat: "", color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onClickingAddBrand()
                              }
                            }
                          },
                          [_vm._v("Add Brand")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.$v.variations.range.$error
                      ? _c("div", { staticClass: "red--text" }, [
                          _vm._v("Please select Range")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-autocomplete", {
                      attrs: {
                        items: _vm.ranges,
                        "item-value": "_id",
                        label: "Range",
                        filter: _vm.filterBrandAndRange
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "selection",
                          fn: function(data) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(data.item.name) +
                                  "\n          "
                              )
                            ]
                          }
                        },
                        {
                          key: "item",
                          fn: function(data) {
                            return [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", {
                                    domProps: {
                                      innerHTML: _vm._s("" + data.item.name)
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.variations.range,
                        callback: function($$v) {
                          _vm.$set(_vm.variations, "range", $$v)
                        },
                        expression: "variations.range"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "v-card__actions" },
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { small: "", flat: "", color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onClickingAddRange()
                              }
                            }
                          },
                          [_vm._v("Add Range")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.$v.variations.fabricPricePerMeter.$error
                      ? _c("div", { staticClass: "red--text" }, [
                          _vm._v("Please enter Fabric Price Per Meter")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-text-field", {
                      staticClass: "disableField",
                      attrs: {
                        label: "Fabric Price Per Meter",
                        disabled: true
                      },
                      on: {
                        change: function($event) {
                          return _vm.getFabricSize()
                        }
                      },
                      model: {
                        value: _vm.variations.fabricPricePerMeter,
                        callback: function($$v) {
                          _vm.$set(_vm.variations, "fabricPricePerMeter", $$v)
                        },
                        expression: "variations.fabricPricePerMeter"
                      }
                    }),
                    _vm._v(" "),
                    _vm.$v.variations.fabricRollWidth.$error
                      ? _c("div", { staticClass: "red--text" }, [
                          _vm._v("Please enter Fabric Roll Width")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-text-field", {
                      staticClass: "disableField",
                      attrs: { label: "Fabric Roll Width", disabled: true },
                      on: {
                        change: function($event) {
                          return _vm.getFabricSize()
                        }
                      },
                      model: {
                        value: _vm.variations.fabricRollWidth,
                        callback: function($$v) {
                          _vm.$set(_vm.variations, "fabricRollWidth", $$v)
                        },
                        expression: "variations.fabricRollWidth"
                      }
                    }),
                    _vm._v(" "),
                    _vm.$v.variations.fabricColorLabel.$error
                      ? _c("div", { staticClass: "red--text" }, [
                          _vm._v("Please enter Fabric - Colour Label")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: { label: "Fabric - Colour Label" },
                      model: {
                        value: _vm.variations.fabricColorLabel,
                        callback: function($$v) {
                          _vm.$set(_vm.variations, "fabricColorLabel", $$v)
                        },
                        expression: "variations.fabricColorLabel"
                      }
                    })
                  ],
              _vm._v(" "),
              _vm.$v.width.$error
                ? _c("div", { staticClass: "red--text" }, [
                    _vm._v("Please enter Width")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "Width" },
                on: {
                  change: function($event) {
                    return _vm.getFabricSize()
                  }
                },
                model: {
                  value: _vm.width,
                  callback: function($$v) {
                    _vm.width = $$v
                  },
                  expression: "width"
                }
              }),
              _vm._v(" "),
              _vm.$v.drop.$error
                ? _c("div", { staticClass: "red--text" }, [
                    _vm._v("Please enter Drop")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "Drop" },
                on: {
                  change: function($event) {
                    return _vm.getFabricSize()
                  }
                },
                model: {
                  value: _vm.drop,
                  callback: function($$v) {
                    _vm.drop = $$v
                  },
                  expression: "drop"
                }
              }),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  items: [
                    "S-Fold",
                    "Pinch Pleat",
                    "Inverted Pleat",
                    "Pencil Pleat",
                    "Knife Pleat"
                  ],
                  label: "Curtain Type"
                },
                model: {
                  value: _vm.variations.curtainType,
                  callback: function($$v) {
                    _vm.$set(_vm.variations, "curtainType", $$v)
                  },
                  expression: "variations.curtainType"
                }
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: { label: "Lining?", color: "primary" },
                model: {
                  value: _vm.variations.lining,
                  callback: function($$v) {
                    _vm.$set(_vm.variations, "lining", $$v)
                  },
                  expression: "variations.lining"
                }
              }),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  attrs: { row: "" },
                  on: {
                    click: function($event) {
                      _vm.getFabricSize(),
                        _vm.resetTrackColor(),
                        _vm.resetTrackType()
                    }
                  },
                  model: {
                    value: _vm.variations.fitting,
                    callback: function($$v) {
                      _vm.$set(_vm.variations, "fitting", $$v)
                    },
                    expression: "variations.fitting"
                  }
                },
                [
                  _c("v-radio", {
                    attrs: { label: "Top", color: "primary", value: "top" }
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: { label: "Face", color: "primary", value: "face" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  attrs: { row: "" },
                  on: {
                    click: function($event) {
                      return _vm.getFabricSize()
                    }
                  },
                  model: {
                    value: _vm.variations.multiplier,
                    callback: function($$v) {
                      _vm.$set(_vm.variations, "multiplier", $$v)
                    },
                    expression: "variations.multiplier"
                  }
                },
                [
                  _c("v-radio", {
                    attrs: { label: "One Way", color: "primary", value: "1" }
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: {
                      label: "Center Open",
                      color: "primary",
                      value: "2"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.$v.variations.controlSide.$error
                ? _c("div", { staticClass: "red--text" }, [
                    _vm._v("Please select Control Side")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.variations.multiplier === "1"
                ? _c(
                    "v-radio-group",
                    {
                      attrs: { row: "" },
                      model: {
                        value: _vm.variations.controlSide,
                        callback: function($$v) {
                          _vm.$set(_vm.variations, "controlSide", $$v)
                        },
                        expression: "variations.controlSide"
                      }
                    },
                    [
                      _c("v-radio", {
                        attrs: {
                          label: "Left",
                          color: "primary",
                          value: "Left"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-radio", {
                        attrs: {
                          label: "Right",
                          color: "primary",
                          value: "Right"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  attrs: { row: "" },
                  on: {
                    click: function($event) {
                      return _vm.getFabricSize()
                    }
                  },
                  model: {
                    value: _vm.variations.fullness,
                    callback: function($$v) {
                      _vm.$set(_vm.variations, "fullness", $$v)
                    },
                    expression: "variations.fullness"
                  }
                },
                [
                  _c("v-radio", {
                    attrs: { label: "100", color: "primary", value: "100" }
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: { label: "80", color: "primary", value: "80" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("CustomizationSelector", {
                attrs: {
                  title: "Track Type",
                  value: _vm.variations.trackType,
                  options: _vm.trackTypeOptions,
                  v: _vm.$v.variations.trackType,
                  error: _vm.$v.variations.trackType.$error
                },
                on: {
                  "selected-option": function($event) {
                    ;(_vm.variations.trackType = $event),
                      _vm.getTrackPrice(
                        _vm.width,
                        "sfold",
                        _vm.variations.fitting,
                        $event
                      )
                  }
                }
              }),
              _vm._v(" "),
              _c("CustomizationSelector", {
                attrs: {
                  title: "Track Color",
                  value: _vm.variations.trackColor,
                  options: _vm.trackColorOptions,
                  v: _vm.$v.variations.trackColor,
                  error: _vm.$v.variations.trackColor.$error
                },
                on: {
                  "selected-option": function($event) {
                    _vm.variations.trackColor = $event
                  }
                }
              }),
              _vm._v(" "),
              ["Designer", "Residential"].includes(_vm.variations.trackType)
                ? _c("CustomizationSelector", {
                    attrs: {
                      title: "Track Flow",
                      value: _vm.variations.trackFlow,
                      options: ["Fixed Flow", "Free Flow"],
                      v: _vm.$v.variations.trackFlow,
                      error: _vm.$v.variations.trackFlow.$error
                    },
                    on: {
                      "selected-option": function($event) {
                        _vm.variations.trackFlow = $event
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("CustomizationSelector", {
                attrs: {
                  title: "Finish to Floor",
                  value: _vm.variations.finishToFloor,
                  options: [
                    "Off the Floor",
                    "Just Touching",
                    "5mm Puddle",
                    "10mm Puddle",
                    "20mm Puddle"
                  ],
                  v: _vm.$v.variations.finishToFloor,
                  error: _vm.$v.variations.finishToFloor.$error
                },
                on: {
                  "selected-option": function($event) {
                    _vm.variations.finishToFloor = $event
                  }
                }
              }),
              _vm._v(" "),
              _c("CustomizationSelector", {
                attrs: {
                  title: "Bottom Finish",
                  value: _vm.variations.bottomFinish,
                  options: ["Weighted", "70mm Hem", "100mm Hem"],
                  v: _vm.$v.variations.bottomFinish,
                  error: _vm.$v.variations.bottomFinish.$error
                },
                on: {
                  "selected-option": function($event) {
                    _vm.variations.bottomFinish = $event
                  }
                }
              }),
              _vm._v(" "),
              _vm.$v.variations.margin.$error
                ? _c("div", { staticClass: "red--text" }, [
                    _vm._v("Please enter Margin")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "Margin", "append-icon": "%" },
                model: {
                  value: _vm.variations.margin,
                  callback: function($$v) {
                    _vm.$set(_vm.variations, "margin", $$v)
                  },
                  expression: "variations.margin"
                }
              }),
              _vm._v(" "),
              _vm.incInstall
                ? [
                    _c("v-checkbox", {
                      attrs: { label: "Install?", color: "primary" },
                      model: {
                        value: _vm.customInstall,
                        callback: function($$v) {
                          _vm.customInstall = $$v
                        },
                        expression: "customInstall"
                      }
                    }),
                    _vm._v(" "),
                    _vm.customInstall
                      ? _c("v-text-field", {
                          attrs: { label: "Install Price" },
                          model: {
                            value: _vm.installPrice,
                            callback: function($$v) {
                              _vm.installPrice = $$v
                            },
                            expression: "installPrice"
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("v-textarea", {
                attrs: { name: "notes", label: "Line Item Notes" },
                model: {
                  value: _vm.notes,
                  callback: function($$v) {
                    _vm.notes = $$v
                  },
                  expression: "notes"
                }
              }),
              _vm._v(" "),
              !_vm.edit
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.createItem()
                        }
                      }
                    },
                    [_vm._v("Add Custom Curtain")]
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.createItem()
                        }
                      }
                    },
                    [_vm._v("Update Custom Curtain")]
                  ),
              _vm._v(" "),
              _c("b", [_vm._v("$" + _vm._s(_vm.total.toFixed(2)))])
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_c("h4", [_vm._v("Summary")])]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-tile",
                        [
                          _c("v-list-tile-content", [
                            _vm._v("Pricing Method:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { staticClass: "align-end" },
                            [_vm._v(_vm._s(_vm.priceType))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c("v-list-tile-content", [_vm._v("Fabric Price:")]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { staticClass: "align-end" },
                            [_vm._v("$" + _vm._s(_vm.fabricPrice))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c("v-list-tile-content", [_vm._v("Fabric Size:")]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { staticClass: "align-end" },
                            [_vm._v(_vm._s(_vm.fabricSize) + "m")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c("v-list-tile-content", [_vm._v("Make Price:")]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { staticClass: "align-end" },
                            [_vm._v("$" + _vm._s(_vm.makePrice))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c("v-list-tile-content", [_vm._v("Track Price:")]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { staticClass: "align-end" },
                            [_vm._v("$" + _vm._s(_vm.trackPrice))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c("v-list-tile-content", [
                            _c("b", [_vm._v("Total Price:")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { staticClass: "align-end" },
                            [_c("b", [_vm._v("$" + _vm._s(_vm.totalPrice))])]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.addBrandDialoug,
            callback: function($$v) {
              _vm.addBrandDialoug = $$v
            },
            expression: "addBrandDialoug"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Add New Brand")]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm.$v.brandNameText.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Enter Brand")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Add Brand" },
                    model: {
                      value: _vm.brandNameText,
                      callback: function($$v) {
                        _vm.brandNameText = $$v
                      },
                      expression: "brandNameText"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.addBrandDialoug = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.onClickingSavedBrand()
                        }
                      }
                    },
                    [_vm._v("Save")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.addRangeDialoug,
            callback: function($$v) {
              _vm.addRangeDialoug = $$v
            },
            expression: "addRangeDialoug"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Add New Range")]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm.$v.selectedBrandFromRangePopup.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Select Brand")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.brands,
                      "item-value": "_id",
                      label: "Select Brand",
                      filter: _vm.filterBrandAndRange
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.item.name) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "item",
                        fn: function(data) {
                          return [
                            _c(
                              "v-list-tile-content",
                              [
                                _c("v-list-tile-title", {
                                  domProps: {
                                    innerHTML: _vm._s("" + data.item.name)
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.selectedBrandFromRangePopup,
                      callback: function($$v) {
                        _vm.selectedBrandFromRangePopup = $$v
                      },
                      expression: "selectedBrandFromRangePopup"
                    }
                  }),
                  _vm._v(" "),
                  _vm.$v.rangeNameText.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Enter Range")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Add Range" },
                    model: {
                      value: _vm.rangeNameText,
                      callback: function($$v) {
                        _vm.rangeNameText = $$v
                      },
                      expression: "rangeNameText"
                    }
                  }),
                  _vm._v(" "),
                  _vm.$v.priceText.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Enter Price")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Add Price" },
                    model: {
                      value: _vm.priceText,
                      callback: function($$v) {
                        _vm.priceText = $$v
                      },
                      expression: "priceText"
                    }
                  }),
                  _vm._v(" "),
                  _vm.$v.widthText.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Enter Width")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Add Width" },
                    model: {
                      value: _vm.widthText,
                      callback: function($$v) {
                        _vm.widthText = $$v
                      },
                      expression: "widthText"
                    }
                  }),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Sheer")]),
                  _vm._v(" "),
                  _vm.$v.sheerOption.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Select Sheer Option")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-radio-group",
                    {
                      attrs: { row: "" },
                      model: {
                        value: _vm.sheerOption,
                        callback: function($$v) {
                          _vm.sheerOption = $$v
                        },
                        expression: "sheerOption"
                      }
                    },
                    [
                      _c("v-radio", {
                        attrs: { label: "Yes", color: "primary", value: "true" }
                      }),
                      _vm._v(" "),
                      _c("v-radio", {
                        attrs: { label: "No", color: "primary", value: "false" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.addRangeDialoug = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.onClickingSavedRange()
                        }
                      }
                    },
                    [_vm._v("Save")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2aeccca2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aeccca2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/CustomCurtains.vue
// module id = null
// module chunks = 